import script from "./ArgonCounterBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonCounterBadge.vue?vue&type=script&setup=true&lang=js"

import "./ArgonCounterBadge.vue?vue&type=style&index=0&id=2d5c5786&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d5c5786"]])

export default __exports__